import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	dropdownTitle: {
		id: 'personal-settings-preference-fields.common.batch-window.dropdown-title',
		defaultMessage: 'Batch Window Preference',
		description: 'Dropdown label for batch window preference.',
		value: 'not required',
	},
	optionTextDef: {
		id: 'personal-settings-preference-fields.common.batch-window.option-text-def',
		defaultMessage: 'Every 3 minutes',
		description: 'Dropdown option. Sets batchWindow to DEFAULT_BATCHING.',
		value: 'DEFAULT_BATCHING',
	},
	optionTextTenMins: {
		id: 'personal-settings-preference-fields.common.batch-window.option-text-ten-mins',
		defaultMessage: 'Every 10 minutes',
		description: 'Dropdown option. Sets batchWindow to TEN_MINUTES.',
		value: 'TEN_MINUTES',
	},
	optionTextThirtyMins: {
		id: 'personal-settings-preference-fields.common.batch-window.option-text-thirty-mins',
		defaultMessage: 'Every 30 minutes',
		description: 'Dropdown option. Sets batchWindow to THIRTY_MINUTES.',
		value: 'THIRTY_MINUTES',
	},
	optionTextSixtyMins: {
		id: 'personal-settings-preference-fields.common.batch-window.option-text-sixty-mins',
		defaultMessage: 'Every 60 minutes',
		description: 'Dropdown option. Sets batchWindow to ONE_HOUR.',
		value: 'ONE_HOUR',
	},
	optionTextOncePerDayAt: {
		id: 'personal-settings-preference-fields.common.batch-window.option-text-once-per-day-at',
		defaultMessage: 'Once per day at...',
		description: 'Dropdown option. Sets batchWindow to ONCE_A_DAY.',
		value: 'ONCE_PER_DAY',
	},
	optionText0900: {
		id: 'personal-settings-preference-fields.common.batch-window.option-text-0900',
		defaultMessage: '9:00 AM',
		description: 'Dropdown option. Sets daily scheduling time to 9:00 AM.',
		value: '09:00',
	},
	optionText5: {
		id: 'personal-settings-preference-fields.common.batch-window.option-text-5',
		defaultMessage: 'No Batching',
		description: 'Dropdown option. Sets batchWindow to NO_BATCHING.',
		value: 'NO_BATCHING',
	},
	batchWindowFieldLabel: {
		id: 'personal-settings-preference-fields.common.batch-window.batch-window-field-label',
		defaultMessage: 'Notifications for the same issue will be grouped together into one email',
		description: 'Dropdown label for batch window preference.',
		value: 'not required',
	},
	batchWindowFieldLabelIssueTermRefresh: {
		id: 'personal-settings-preference-fields.common.batch-window.batch-window-field-label-issue-term-refresh',
		defaultMessage: 'Notifications for the same work item will be grouped together into one email',
		description: 'Dropdown label for batch window preference.',
		value: 'not required',
	},
	timePickerLabel: {
		id: 'personal-settings-preference-fields.common.batch-window.time-picker-label',
		defaultMessage: 'Select notification time',
		description: 'Label for the time picker when selecting a specific time for daily notifications',
		value: 'not required',
	},
	selectBatchWindowLabel: {
		id: 'personal-settings-preference-fields.common.batch-window.select-batch-window-label',
		defaultMessage: 'Email notification frequency',
		description: 'Label for the select dropdown to choose batch window preference',
		value: 'not required',
	},
});
